import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectAttachmentsBiData, selectBiData } from '../selectors';
import {
  attachingMethodMapper,
  AttachmentErrorBiData,
  attachmentErrorTypeMapper,
  BiEventLogger,
} from '../types';
import { getAttachmentBi, getRuntimeDataForBi } from '../utils';

export const logChatbotErrorMessageAppears: BiEventLogger<AttachmentErrorBiData> = async (state, data) => {
  const biData = selectBiData(state);
  const { attachmentsLength, attachments, attachingMethod } = selectAttachmentsBiData(state);
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  const { validFiles, invalidFiles, attachingMethod: failedAttachingMethod, errorType } = data;
  const validFilesBi = getAttachmentBi(validFiles);

  // increase count for attaching method with valid files(as result we should count already attached files + valid files)
  attachingMethod[attachingMethodMapper[failedAttachingMethod]] += validFiles.length;

  biLogger.chatbotErrorMessageAppears({
    // files are already attached and valid files user is trying to attach but see the error
    attached_files: JSON.stringify([...attachments, ...validFilesBi]),
    // counter of attaching method for already attached files and valid files user is trying to attach but see the error
    attaching_method: JSON.stringify(attachingMethod),
    number_of_files: attachmentsLength + validFiles.length,

    // information about invalid files(reason why we display an error)
    invalid_files: JSON.stringify(getAttachmentBi(invalidFiles)),
    number_of_invalid_files: invalidFiles.length,
    invalid_files_attaching_method: attachingMethodMapper[failedAttachingMethod],
    error_type: attachmentErrorTypeMapper[errorType],

    // common BI fields
    node_id: biData.nodeId,
    conversation_id: biData.conversationId,
    intent_id: biData.intentId,
    main_option_name: biData.mainOptionName,
    session_id: sessionId,
    context_platform: contextBi?.context_platform,
    context_area: contextBi?.context_area,
    context_parenturl: contextBi?.context_parenturl,
    context_page_urlchunks: contextBi?.context_page_urlchunks,
    context_uuid: contextBi?.context_uuid,
    context_domain: contextBi?.context_domain,
    context_page_queryparams: contextBi?.context_page_queryparams,
    context_msid: contextBi?.context_msid,
    context_page_numlevels: contextBi?.context_page_numlevels,
    context_page_toplevelroute: contextBi?.context_page_toplevelroute,
    mapping_product: contextBi?.mapping_product,
    mapping_url: contextBi?.mapping_url,
    user_experience: contextBi?.user_experience,
    lang: locale,
    chatbot_view: contextBi?.chatbot_view,
    context_iframeurllist: undefined,
    ab_test_version: undefined,
    main_option_id: undefined,
    user_intent: undefined,
    ai_user_intent: undefined,
    ai_user_intent_type: undefined,
    node_type_id: undefined,
    node_type: undefined,
    node_name: undefined,
  });
};
